import "@js-joda/locale_en-us";
import "material-icons/iconfont/material-icons.css";
import "material-symbols/outlined.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./screens/App";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
